import { ChartBar, Gauge, Gear, Lightning, SquaresFour, Yarn } from "@phosphor-icons/react"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { Module } from "~/components/design-system/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { Button } from "~/components/design-system/components"
import { type HeaderTab } from "~/components/reusable/HeaderTabs"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import NotFound from "~/components/reusable/NotFound"
import { ManageNoosSupplyPlanDialog } from "~/components/noos-supply-plan/ManageNoosSupplyPlanDialog"
import { NoosSupplyPlanDetailProvider } from "~/context/NoosSupplyPlanDetailProvider"
import { api } from "~/utils/api"

export const Route = createFileRoute("/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout")({
  component: RouteComponent,
})

const tabs: HeaderTab[] = [
  {
    label: "Overview",
    icon: <SquaresFour />,
    path: "/procurement/supply-plan/noos/$supplyPlanId/overview" as const,
  },
  {
    label: "Triggers",
    icon: <Lightning />,
    path: "/procurement/supply-plan/noos/$supplyPlanId/triggers" as const,
  },
  {
    label: "Availability",
    icon: <Gauge />,
    path: "/procurement/supply-plan/noos/$supplyPlanId/availability" as const,
  },
  {
    label: "Capacity Planning",
    icon: <ChartBar />,
    path: "/procurement/supply-plan/noos/$supplyPlanId/capacity-planning" as const,
  },
  {
    label: "Greige",
    icon: <Yarn />,
    path: "/procurement/supply-plan/noos/$supplyPlanId/greige" as const,
  },
]

function RouteComponent() {
  const { supplyPlanId } = Route.useParams()
  const { data: supplyPlans, isLoading } = api.supplyPlan.getAll.useQuery()

  if (isLoading) return <LoadingOverlay />

  const supplyPlan = supplyPlans?.find((p) => p.id === Number(supplyPlanId))
  if (!supplyPlan) return <NotFound />

  return (
    <NoosSupplyPlanDetailProvider supplyPlan={supplyPlan}>
      <Module
        breadcrumb={
          <BreadcrumbWrapper
            items={[
              { label: "Procurement", href: "/procurement" },
              { label: "Supply Plan", href: "/procurement/supply-plan" },
              { label: supplyPlan.name },
            ]}
          />
        }
        actions={
          <ManageNoosSupplyPlanDialog
            supplyPlan={supplyPlan}
            customTrigger={
              <Button variant="neutral" size="sm" aria-label="Supply plan settings">
                <Gear />
                Supply plan settings
              </Button>
            }
          />
        }
        tabs={{ items: tabs, path: "/procurement/supply-plan/noos/$supplyPlanId" }}
      >
        <Outlet />
      </Module>
    </NoosSupplyPlanDetailProvider>
  )
}
